/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useContext, useState} from 'react'
import {useDispatch} from 'react-redux'

import {getTicketActions} from '../action/actionCreators'
import TicketActionsForm from './TicketActionsForm'
import API from 'config/API'
import {ModalContext} from 'context/ModalContext'

import {Notifier} from 'components/Notifier'

const AddTicketAction = ({ticketCategory}) => {
  const dispatch = useDispatch()
  const {hideModal} = useContext(ModalContext)
  const [loading, setLoading] = useState(false)

  const onSubmit = async (values, setError) => {
    try {
      setLoading(true)
      await API.post(`/ticket/ticket_actions`, {
        ...values,
        duration: 1,
        ticket_category_id: ticketCategory,
        model_type: values.model_type?.value,
      })
      setLoading(false)
      dispatch(getTicketActions(1, 10, ticketCategory, ''))
      hideModal()
      Notifier.successMessage('Action has been created!')
    } catch (error) {
      for (let err in error.response.data.errors) {
        setError(err, {message: error.response.data.errors[err][0]})
      }
      setLoading(false)
    }
  }

  return <TicketActionsForm onSubmitHandler={onSubmit} loading={loading} />
}

export default AddTicketAction
